import * as tokens from "../tokens";

export const theme = {
  ...tokens,
};
